export default __webpack_public_path__ + "static/media/logo-white.f52782e1.svg";